export const FORMATION_LESSONS = [
  {
    id: 'formation-1',
    numero: 1,
    titre: "Comprendre le CPF",
    sousTitre: "C'est quoi, à quoi ça sert ?",
    contexte: "Marie a entendu parler du CPF à la radio. Elle a des droits formation mais ne sait pas comment les utiliser.",
    explication: [
      "**Le CPF (Compte Personnel de Formation)** est un compte alimenté en euros à chaque heure travaillée.",
      "Tout salarié accumule **500 € par an**, jusqu'à un plafond de **5 000 €** (ou 8 000 € pour les peu qualifiés).",
      "Cet argent vous appartient — il reste disponible même si vous changez d'employeur ou perdez votre emploi.",
      "Il finance des **formations certifiantes** : permis de conduire, langues, bureautique, reconversion…",
      "Pour consulter votre solde : **moncompteformation.gouv.fr** — connexion avec France Connect.",
    ],
    question: "À qui appartient l'argent accumulé sur votre CPF ?",
    options: [
      { id: 'a', text: "À votre employeur", correct: false },
      { id: 'b', text: "À vous, même si vous changez de travail", correct: true },
      { id: 'c', text: "À Pôle emploi", correct: false },
    ],
    explication_reponse: "Votre CPF vous suit toute votre carrière. L'argent reste le vôtre même en cas de chômage ou de changement d'entreprise.",
  },
  {
    id: 'formation-2',
    numero: 2,
    titre: "Consulter son solde CPF",
    sousTitre: "Se connecter à moncompteformation.gouv.fr",
    contexte: "Marie veut savoir combien elle a sur son CPF. Elle n'a jamais utilisé ce site.",
    explication: [
      "Rendez-vous sur **moncompteformation.gouv.fr** depuis votre navigateur.",
      "Cliquez sur **'Me connecter'** puis choisissez **France Connect** (utilisez vos identifiants Ameli, impôts ou La Poste).",
      "Une fois connecté, votre **solde en euros** s'affiche directement sur la page d'accueil.",
      "Vous pouvez aussi **parcourir le catalogue** des formations disponibles avec le moteur de recherche.",
      "Si votre solde semble incorrect, contactez la **hotline CPF : 09 69 37 07 00** (appel non surtaxé).",
    ],
    question: "Quel service permet de se connecter à moncompteformation.gouv.fr ?",
    options: [
      { id: 'a', text: "Un compte Google", correct: false },
      { id: 'b', text: "France Connect", correct: true },
      { id: 'c', text: "Un code envoyé par courrier", correct: false },
    ],
    explication_reponse: "France Connect centralise l'accès à tous les services publics. Vos identifiants Ameli ou impôts.gouv.fr fonctionnent.",
  },
  {
    id: 'formation-3',
    numero: 3,
    titre: "Choisir et financer une formation",
    sousTitre: "Trouver, comparer, s'inscrire",
    contexte: "Marie veut se former à Excel pour être plus à l'aise au travail. Elle a 1 200 € sur son CPF.",
    explication: [
      "Dans la barre de recherche, tapez le **nom de la formation** souhaitée (ex : 'Excel', 'anglais', 'permis B').",
      "Chaque formation affiche sa **durée, son prix, ses avis et son organisme**. Comparez avant de choisir.",
      "Si le coût dépasse votre solde CPF, vous pouvez payer la **différence de votre poche** ou demander un abondement à votre employeur.",
      "Cliquez sur **'Je m'inscris'** — le paiement est prélevé directement sur votre CPF, vous ne débourserez rien.",
      "⚠️ **Méfiez-vous des appels téléphoniques** promettant des formations gratuites — c'est souvent une arnaque au CPF.",
    ],
    question: "Que se passe-t-il si le prix de la formation dépasse votre solde CPF ?",
    options: [
      { id: 'a', text: "La formation est refusée automatiquement", correct: false },
      { id: 'b', text: "Vous pouvez payer la différence ou demander un abondement", correct: true },
      { id: 'c', text: "Le CPF vous prête de l'argent", correct: false },
    ],
    explication_reponse: "Le CPF couvre jusqu'à votre solde. Vous complétez le reste vous-même ou via votre employeur, votre OPCO ou Pôle emploi.",
  },
  {
    id: 'formation-4',
    numero: 4,
    titre: "Autres aides à la formation",
    sousTitre: "CPF de transition, bilan de compétences, VAE",
    contexte: "Marie envisage une reconversion. Elle ne sait pas s'il existe d'autres dispositifs que le CPF.",
    explication: [
      "Le **CPF de transition professionnelle** permet de financer une formation longue pour changer de métier, tout en gardant son salaire.",
      "Le **bilan de compétences** (financé CPF) aide à faire le point sur ses aptitudes et définir un projet professionnel.",
      "La **VAE (Validation des Acquis de l'Expérience)** permet d'obtenir un diplôme grâce à son expérience, sans repasser par l'école.",
      "**Pôle emploi** (maintenant **France Travail**) propose aussi des formations gratuites pour les demandeurs d'emploi.",
      "Pour être guidé gratuitement : appelez le **Conseil en Évolution Professionnelle (CEP)** au **09 69 37 07 00**.",
    ],
    question: "Qu'est-ce que la VAE ?",
    options: [
      { id: 'a', text: "Une aide financière pour payer ses factures", correct: false },
      { id: 'b', text: "Un diplôme obtenu grâce à son expérience professionnelle", correct: true },
      { id: 'c', text: "Un contrat d'apprentissage pour les jeunes", correct: false },
    ],
    explication_reponse: "La VAE reconnaît officiellement ce que vous savez faire grâce à vos années de travail. C'est un droit ouvert à tous.",
  },
];
